
export class IC6_0PresQRCodeBundle{
  clinicName = "洪文武診所";
clinicPhone = "02-12345678";
clinicCode = '3538011678';
clinicAddress = "新北市三重區集美街162號1樓";
createDate = "2024-02-19T14:30:00+01:00";
doctorName = '洪文武';
patientName = "甄○康";
patientCId = "Z299999992";
patientGender = "Female";
patientBirthDate = "1985-01-02";
patientMedicalRecordNumber = "Med000001";
histCase = "01";
histCaseDesc = "西醫一般案件";
MainDisease = "A00";
MainDiseaseDesc = "霍亂"
Itreatnum = "733A8RZ27GEHMJ2B0SHN";
Isqno = "A000";
PillDays = 3;
PillTotal = '9.00';
MedDays = 3;
PillStdCode = 'A016348100';
DrMaskCId = 'A1*****8028';
DayStart = '2025-06-20T00:00:00+08:00';
DayEnd = '2025-06-22T00:00:00+08:00';
getbundleTemplate(){
   return `{
  "resourceType": "Bundle",
  "meta": {
    "profile": [
      "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Bundle-EP"
    ]
  },
  "identifier": {
    "system": "http://www.moi.gov.tw/",
    "value": "bun-10"
  },
  "type": "document",
  "timestamp": "${this.createDate}",
  "entry": [
    {
      "fullUrl": "urn:uuid:0b269dc9-d7ea-49bb-a6a2-de623be4f8e0",
      "resource": {
        "resourceType": "Composition",
        "id": "com-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Composition-EP"
          ]
        },
        "status": "final",
        "type": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "57833-6",
              "display": "Prescription for medication"
            }
          ]
        },
        "subject": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "encounter": {
          "reference": "urn:uuid:828df43a-b780-46e0-9e61-27f993dd833a"
        },
        "date": "${this.createDate}",
        "author": [
          {
            "reference": "urn:uuid:da25067a-86ae-4ad7-9421-f71987062930"
          },
          {
            "reference": "urn:uuid:02dc25c0-93b0-48ec-829a-9d8ed18c83e2"
          }
        ],
        "title": "電子處方箋",
        "custodian": {
          "reference": "urn:uuid:da25067a-86ae-4ad7-9421-f71987062930"
        },
        "section": [
          {
            "title": "診斷1",
            "code": {
              "coding": [
                {
                  "system": "http://loinc.org",
                  "code": "29548-5",
                  "display": "Diagnosis Narrative"
                }
              ]
            },
            "entry": [
              {
                "reference": "urn:uuid:07bce129-666e-4ab4-9717-9a44a1f0f84d"
              }
            ]
          },
          {
            "title": "就醫身分別",
            "code": {
              "coding": [
                {
                  "system": "http://loinc.org",
                  "code": "29762-2"
                }
              ]
            },
            "entry": [
              {
                "reference": "urn:uuid:fa5a52f4-3751-4ed3-afb2-eaae1bc91288"
              }
            ]
          },
          {
            "title": "處方內容",
            "code": {
              "coding": [
                {
                  "system": "http://loinc.org",
                  "code": "29551-9",
                  "display": "Medication prescribed Narrative"
                }
              ]
            },
            "entry": [
              {
                "reference": "urn:uuid:8794daf0-129f-45df-bce9-f6e307f54347"
              },
              {
                "reference": "urn:uuid:15b7441d-7e12-4132-bd23-882ba8a72a3a"
              }
            ]
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:da25067a-86ae-4ad7-9421-f71987062930",
      "resource": {
        "resourceType": "Organization",
        "id": "org-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Organization-EP"
          ]
        },
        "identifier": [
          {
            "type": {
              "coding": [
                {
                  "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                  "code": "PRN"
                }
              ]
            },
            "system": "http://ns.electronichealth.net.au/id/hi/hpio/1.0",
            "value": "${this.clinicCode}"
          }
        ],
        "name": "${this.clinicName}",
        "telecom": [
          {
            "system": "phone",
            "value": "${this.clinicPhone}",
            "use": "work"
          }
        ],
        "address": [
          {
            "use": "work",
            "text": "${this.clinicAddress}"
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143",
      "resource": {
        "resourceType": "Patient",
        "id": "pat-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Patient-EP"
          ]
        },
        "extension": [
          {
            "url": "https://twcore.mohw.gov.tw/ig/twcore/StructureDefinition/person-age",
            "valueAge": {
              "value": 39,
              "system": "http://unitsofmeasure.org",
              "code": "a"
            }
          }
        ],
        "identifier": [
          {
            "use": "official",
            "system": "http://www.moi.gov.tw",
            "value": "${this.patientCId}"
          }
        ],
        "name": [
          {
            "use": "official",
            "text": "${this.patientName}"
          }
        ],
        "gender": "${this.patientGender}",
        "birthDate": "${this.patientBirthDate}"
      }
    },
    {
      "fullUrl": "urn:uuid:02dc25c0-93b0-48ec-829a-9d8ed18c83e2",
      "resource": {
        "resourceType": "Practitioner",
        "id": "pra-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Practitioner-EP"
          ]
        },
        "name": [
          {
            "use": "official",
            "text": "${this.doctorName}"
          }
        ],
        "qualification": [
          {
            "identifier": [
              {
                "use": "official",
                "system": "https://www.mohw.gov.tw/",
                "value": "${this.DrMaskCId}"
              }
            ],
            "code": {
              "coding": [
                {
                  "system": "http://snomed.info/sct",
                  "code": "309343006"
                }
              ]
            }
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:828df43a-b780-46e0-9e61-27f993dd833a",
      "resource": {
        "resourceType": "Encounter",
        "id": "enc-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Encounter-EP"
          ]
        },
        "identifier": [
          {
            "system": "http://www.moi.gov.tw",
            "value": "${this.Itreatnum}"
          },
          {
            "system": "http://www.moi.gov.tw",
            "value": "${this.Isqno}"
          }
        ],
        "status": "finished",
        "class": {
          "system": "https://twcore.mohw.gov.tw/ig/emr/CodeSystem/casetype",
          "code": "${this.histCase}",
          "display": "${this.histCaseDesc}"
        },
        "serviceType": {
          "coding": [
            {
              "system": "http://snomed.info/sct",
              "code": "419772000"
            }
          ],
          "text": "普通外科"
        },
        "subject": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "period": {
          "start": "2023-02-23"
        }
      }
    },
    {
      "fullUrl": "urn:uuid:fa5a52f4-3751-4ed3-afb2-eaae1bc91288",
      "resource": {
        "resourceType": "Coverage",
        "id": "cov-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Coverage-EMR"
          ]
        },
        "status": "active",
        "type": {
          "coding": [
            {
              "system": "https://twcore.mohw.gov.tw/ig/emr/CodeSystem/paymentcategory",
              "code": "4"
            }
          ],
          "text": "普通疾病"
        },
        "beneficiary": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "payor": [
          {
            "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:07bce129-666e-4ab4-9717-9a44a1f0f84d",
      "resource": {
        "resourceType": "Condition",
        "id": "con-1-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Condition-EP"
          ]
        },
        "clinicalStatus": {
          "coding": [
            {
              "system": "http://terminology.hl7.org/CodeSystem/condition-clinical",
              "code": "active"
            }
          ]
        },
        "category": [
          {
            "coding": [
              {
                "system": "http://terminology.hl7.org/CodeSystem/condition-category",
                "code": "problem-list-item",
                "display": "Problem List Item"
              }
            ]
          }
        ],
        "code": {
          "coding": [
            {
              "system": "https://twcore.mohw.gov.tw/ig/twcore/CodeSystem/icd-10-cm-2021-tw",
              "code": "${this.MainDisease}",
              "display" : "${this.MainDiseaseDesc}"
            }
          ]
        },
        "subject": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "note": [
          {
            "text": "001"
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:8794daf0-129f-45df-bce9-f6e307f54347",
      "resource": {
        "resourceType": "Medication",
        "id": "med-1-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Medication-EP"
          ]
        },
        "code": {
          "coding": [
            {
              "system": "https://twcore.mohw.gov.tw/ig/twcore/CodeSystem/medication-nhi-tw",
              "code": "${this.PillStdCode}"
            }
          ],
          "text": "RHIN TABLETS 'GCPC'"
        },
        "form": {
          "coding": [
            {
              "system": "http://terminology.hl7.org/CodeSystem/v3-orderableDrugForm",
              "code": "TAB"
            }
          ],
          "text": "TAB"
        },
        "ingredient": [
          {
            "itemCodeableConcept": {
              "coding": [
                {
                  "code": "RHIN TABLETS 'GCPC'"
                }
              ]
            },
            "strength": {
              "numerator": {
                "value": 250,
                "unit": "mg",
                "system": "http://unitsofmeasure.org",
                "code": "mg"
              },
              "denominator": {
                "value": 1,
                "unit": "tablet",
                "system": "http://unitsofmeasure.org"
              }
            }
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:15b7441d-7e12-4132-bd23-882ba8a72a3a",
      "resource": {
        "resourceType": "MedicationRequest",
        "id": "med-req-1-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/MedicationRequest-EP"
          ]
        },
        "extension": [
          {
            "url": "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Extension-TotalDuration",
            "valueQuantity": {
              "value": ${this.MedDays},
              "unit": "days"
            }
          }
        ],
        "identifier": [
          {
            "value": "${this.patientMedicalRecordNumber}"
          },
          {
            "value": "1"
          }
        ],
        "status": "active",
        "intent": "order",
        "category": [
          {
            "coding": [
              {
                "system": "https://twcore.mohw.gov.tw/ig/emr/CodeSystem/prescription",
                "code": "A"
              }
            ]
          }
        ],
        "medicationReference": {
          "reference": "urn:uuid:8794daf0-129f-45df-bce9-f6e307f54347"
        },
        "subject": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "insurance": [
          {
            "reference": "urn:uuid:fa5a52f4-3751-4ed3-afb2-eaae1bc91288"
          }
        ],
        "note": [
          {
            "text": "A"
          },
          {
            "text": "否"
          }
        ],
        "dosageInstruction": [
          {
            "timing": {
              "repeat": {
                "frequency": 1,
                "period": 1,
                "periodUnit": "d"
              }
            },
            "route": {
              "coding": [
                {
                  "system": "http://snomed.info/sct",
                  "code": "26643006"
                }
              ]
            },
            "doseAndRate": [
              {
                "doseQuantity": {
                  "value": 1.00,
                  "unit": "tablet",
                  "system": "http://unitsofmeasure.org"
                },
                "rateRatio": {
                  "numerator": {
                    "value": 1.00,
                    "unit": "tablet",
                    "system": "http://unitsofmeasure.org"
                  },
                  "denominator": {
                    "value": 1,
                    "unit": "d",
                    "system": "http://unitsofmeasure.org"
                  }
                }
              }
            ]
          }
        ],
        "dispenseRequest": {
          "validityPeriod": {
            "start": "${this.DayStart}",
            "end": "${this.DayEnd}"
          },
          "numberOfRepeatsAllowed": 1,
          "quantity": {
            "value": ${this.PillTotal},
            "unit": "tablets",
            "system": "http://unitsofmeasure.org"
          },
          "expectedSupplyDuration": {
            "value": ${this.PillDays},
            "unit": "days",
            "system": "http://unitsofmeasure.org",
            "code": "d"
          }
        }
      }
    }
  ]
}`;
}
getbundleTemplateTest(){
   return `{
  "resourceType": "Bundle",
  "meta": {
    "profile": [
      "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Bundle-EP"
    ]
  },
  "identifier": {
    "system": "http://www.moi.gov.tw/",
    "value": "bun-10"
  },
  "type": "document",
  "timestamp": "2025-06-20T13:05:57+01:00",
  "entry": [
    {
      "fullUrl": "urn:uuid:0b269dc9-d7ea-49bb-a6a2-de623be4f8e0",
      "resource": {
        "resourceType": "Composition",
        "id": "com-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Composition-EP"
          ]
        },
        "status": "final",
        "type": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "57833-6",
              "display": "Prescription for medication"
            }
          ]
        },
        "subject": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "encounter": {
          "reference": "urn:uuid:828df43a-b780-46e0-9e61-27f993dd833a"
        },
        "date": "2025-06-20T13:05:57+01:00",
        "author": [
          {
            "reference": "urn:uuid:da25067a-86ae-4ad7-9421-f71987062930"
          },
          {
            "reference": "urn:uuid:02dc25c0-93b0-48ec-829a-9d8ed18c83e2"
          }
        ],
        "title": "電子處方箋",
        "custodian": {
          "reference": "urn:uuid:da25067a-86ae-4ad7-9421-f71987062930"
        },
        "section": [
          {
            "title": "診斷1",
            "code": {
              "coding": [
                {
                  "system": "http://loinc.org",
                  "code": "29548-5",
                  "display": "Diagnosis Narrative"
                }
              ]
            },
            "entry": [
              {
                "reference": "urn:uuid:07bce129-666e-4ab4-9717-9a44a1f0f84d"
              }
            ]
          },
          {
            "title": "就醫身分別",
            "code": {
              "coding": [
                {
                  "system": "http://loinc.org",
                  "code": "29762-2"
                }
              ]
            },
            "entry": [
              {
                "reference": "urn:uuid:fa5a52f4-3751-4ed3-afb2-eaae1bc91288"
              }
            ]
          },
          {
            "title": "處方內容",
            "code": {
              "coding": [
                {
                  "system": "http://loinc.org",
                  "code": "29551-9",
                  "display": "Medication prescribed Narrative"
                }
              ]
            },
            "entry": [
              {
                "reference": "urn:uuid:8794daf0-129f-45df-bce9-f6e307f54347"
              },
              {
                "reference": "urn:uuid:15b7441d-7e12-4132-bd23-882ba8a72a3a"
              }
            ]
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:da25067a-86ae-4ad7-9421-f71987062930",
      "resource": {
        "resourceType": "Organization",
        "id": "org-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Organization-EP"
          ]
        },
        "identifier": [
          {
            "type": {
              "coding": [
                {
                  "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                  "code": "PRN"
                }
              ]
            },
            "system": "http://ns.electronichealth.net.au/id/hi/hpio/1.0",
            "value": "3536012855"
          }
        ],
        "name": "展望伊生診所",
        "telecom": [
          {
            "system": "phone",
            "value": "02-12345678",
            "use": "work"
          }
        ],
        "address": [
          {
            "use": "work",
            "text": "TEST"
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143",
      "resource": {
        "resourceType": "Patient",
        "id": "pat-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Patient-EP"
          ]
        },
        "extension": [
          {
            "url": "https://twcore.mohw.gov.tw/ig/twcore/StructureDefinition/person-age",
            "valueAge": {
              "value": 39,
              "system": "http://unitsofmeasure.org",
              "code": "a"
            }
          }
        ],
        "identifier": [
          {
            "use": "official",
            "system": "http://www.moi.gov.tw",
            "value": "Z299999992"
          }
        ],
        "name": [
          {
            "use": "official",
            "text": "曾奕綺"
          }
        ],
        "gender": "female",
        "birthDate": "1986-05-27"
      }
    },
    {
      "fullUrl": "urn:uuid:02dc25c0-93b0-48ec-829a-9d8ed18c83e2",
      "resource": {
        "resourceType": "Practitioner",
        "id": "pra-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Practitioner-EP"
          ]
        },
        "name": [
          {
            "use": "official",
            "text": "鄒為之"
          }
        ],
        "qualification": [
          {
            "identifier": [
              {
                "use": "official",
                "system": "https://www.mohw.gov.tw/",
                "value": "A1*****8028"
              }
            ],
            "code": {
              "coding": [
                {
                  "system": "http://snomed.info/sct",
                  "code": "309343006"
                }
              ]
            }
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:828df43a-b780-46e0-9e61-27f993dd833a",
      "resource": {
        "resourceType": "Encounter",
        "id": "enc-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Encounter-EP"
          ]
        },
        "identifier": [
          {
            "system": "http://www.moi.gov.tw",
            "value": "733A8RZ27GEHMJ2B0SHN"
          },
          {
            "system": "http://www.moi.gov.tw",
            "value": "Z000"
          }
        ],
        "status": "finished",
        "class": {
          "system": "https://twcore.mohw.gov.tw/ig/emr/CodeSystem/casetype",
          "code": "01",
          "display": "西醫一般案件"
        },
        "serviceType": {
          "coding": [
            {
              "system": "http://snomed.info/sct",
              "code": "419772000"
            }
          ],
          "text": "普通外科"
        },
        "subject": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "period": {
          "start": "2023-02-23"
        }
      }
    },
    {
      "fullUrl": "urn:uuid:fa5a52f4-3751-4ed3-afb2-eaae1bc91288",
      "resource": {
        "resourceType": "Coverage",
        "id": "cov-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Coverage-EMR"
          ]
        },
        "status": "active",
        "type": {
          "coding": [
            {
              "system": "https://twcore.mohw.gov.tw/ig/emr/CodeSystem/paymentcategory",
              "code": "4"
            }
          ],
          "text": "普通疾病"
        },
        "beneficiary": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "payor": [
          {
            "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:07bce129-666e-4ab4-9717-9a44a1f0f84d",
      "resource": {
        "resourceType": "Condition",
        "id": "con-1-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Condition-EP"
          ]
        },
        "clinicalStatus": {
          "coding": [
            {
              "system": "http://terminology.hl7.org/CodeSystem/condition-clinical",
              "code": "active"
            }
          ]
        },
        "category": [
          {
            "coding": [
              {
                "system": "http://terminology.hl7.org/CodeSystem/condition-category",
                "code": "problem-list-item",
                "display": "Problem List Item"
              }
            ]
          }
        ],
        "code": {
          "coding": [
            {
              "system": "https://twcore.mohw.gov.tw/ig/twcore/CodeSystem/icd-10-cm-2021-tw",
              "code": "J00",
	      "display" : "急性鼻咽炎（感冒）" 
            }
          ]
        },
        "subject": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "note": [
          {
            "text": "001"
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:8794daf0-129f-45df-bce9-f6e307f54347",
      "resource": {
        "resourceType": "Medication",
        "id": "med-1-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Medication-EP"
          ]
        },
        "code": {
          "coding": [
            {
              "system": "https://twcore.mohw.gov.tw/ig/twcore/CodeSystem/medication-nhi-tw",
              "code": "A016348100"
            }
          ],
          "text": "RHIN TABLETS 'GCPC'"
        },
        "form": {
          "coding": [
            {
              "system": "http://terminology.hl7.org/CodeSystem/v3-orderableDrugForm",
              "code": "TAB"
            }
          ],
          "text": "TAB"
        },
        "ingredient": [
          {
            "itemCodeableConcept": {
              "coding": [
                {
                  "code": "RHIN TABLETS 'GCPC'"
                }
              ]
            },
            "strength": {
              "numerator": {
                "value": 250,
                "unit": "mg",
                "system": "http://unitsofmeasure.org",
                "code": "mg"
              },
              "denominator": {
                "value": 1,
                "unit": "tablet",
                "system": "http://unitsofmeasure.org"
              }
            }
          }
        ]
      }
    },
    {
      "fullUrl": "urn:uuid:15b7441d-7e12-4132-bd23-882ba8a72a3a",
      "resource": {
        "resourceType": "MedicationRequest",
        "id": "med-req-1-ep",
        "meta": {
          "profile": [
            "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/MedicationRequest-EP"
          ]
        },
        "extension": [
          {
            "url": "https://twcore.mohw.gov.tw/ig/emr/StructureDefinition/Extension-TotalDuration",
            "valueQuantity": {
              "value": 3,
              "unit": "days"
            }
          }
        ],
        "identifier": [
          {
            "value": "Med000001"
          },
          {
            "value": "1"
          }
        ],
        "status": "active",
        "intent": "order",
        "category": [
          {
            "coding": [
              {
                "system": "https://twcore.mohw.gov.tw/ig/emr/CodeSystem/prescription",
                "code": "A"
              }
            ]
          }
        ],
        "medicationReference": {
          "reference": "urn:uuid:8794daf0-129f-45df-bce9-f6e307f54347"
        },
        "subject": {
          "reference": "urn:uuid:7f0fb89f-7ee8-40a5-91f2-c8d97d353143"
        },
        "insurance": [
          {
            "reference": "urn:uuid:fa5a52f4-3751-4ed3-afb2-eaae1bc91288"
          }
        ],
        "note": [
          {
            "text": "A"
          },
          {
            "text": "否"
          }
        ],
        "dosageInstruction": [
          {
            "timing": {
              "repeat": {
                "frequency": 1,
                "period": 1,
                "periodUnit": "d"
              }
            },
            "route": {
              "coding": [
                {
                  "system": "http://snomed.info/sct",
                  "code": "26643006"
                }
              ]
            },
            "doseAndRate": [
              {
                "doseQuantity": {
                  "value": 1.00,
                  "unit": "tablet",
                  "system": "http://unitsofmeasure.org"
                },
                "rateRatio": {
                  "numerator": {
                    "value": 1.00,
                    "unit": "tablet",
                    "system": "http://unitsofmeasure.org"
                  },
                  "denominator": {
                    "value": 1,
                    "unit": "d",
                    "system": "http://unitsofmeasure.org"
                  }
                }
              }
            ]
          }
        ],
        "dispenseRequest": {
          "validityPeriod": {
            "start": "2025-06-20T00:00:00+08:00",
            "end": "2025-06-22T00:00:00+08:00"
          },
          "numberOfRepeatsAllowed": 1,
          "quantity": {
            "value": 9.00,
            "unit": "tablets",
            "system": "http://unitsofmeasure.org"
          },
          "expectedSupplyDuration": {
            "value": 3,
            "unit": "days",
            "system": "http://unitsofmeasure.org",
            "code": "d"
          }
        }
      }
    }
  ]
}`;
}
ddDaysKeepOffset(input: string, daysToAdd: number): string {
      // 解析原字串為 Date 物件（會轉成 UTC 時間）
      const date = new Date(input);

      // 加上天數
      date.setDate(date.getDate() + daysToAdd);

      // 從原字串取出 offset（如 +08:00）
      const offsetMatch = input.match(/([+-]\d{2}:\d{2})$/);
      const offsetStr = offsetMatch ? offsetMatch[1] : '+00:00';

      // 格式化日期
      const pad = (n: number) => n.toString().padStart(2, '0');
      const yyyy = date.getFullYear();
      const MM = pad(date.getMonth() + 1);
      const dd = pad(date.getDate());
      const hh = pad(date.getHours());
      const mm = pad(date.getMinutes());
      const ss = pad(date.getSeconds());

      return `${yyyy}-${MM}-${dd}T${hh}:${mm}:${ss}${offsetStr}`;
  }
}
